import { Tooltip } from '@design-system/components/tooltip/tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import reorderProgramsHint from '../../assets/reorder-programs-hint.png';

import * as styles from './ProgramsListHeader.css';

const SoldAsTooltipContent = () => (
  <div
    className={styles.tooltipContent}
    data-testid="programs-sold-as-tooltip-content"
  >
    <div className={styles.tooltipText}>
      <span className={styles.tooltipHeading}>Reorder your programs</span>
      <span className={styles.tooltipBody}>
        Choose a <span className={styles.tooltipItalic}>Sold as</span> filter to
        control the order your customers see programs in your mobile app.
      </span>
    </div>
    <img
      src={reorderProgramsHint}
      alt=""
      className={styles.tooltipIllustration}
      data-testid="programs-sold-as-tooltip-illustration"
    />
  </div>
);

type ProgramsListHeaderProps = {
  isDnDEnabled: boolean;
};

export const ProgramsListHeader = ({
  isDnDEnabled,
}: ProgramsListHeaderProps) => {
  return (
    <div
      className={styles.header({ dnd: isDnDEnabled })}
      data-testid="programs-list-header"
    >
      {isDnDEnabled ? <span /> : null}
      <span />
      <span className={styles.label}>Name</span>
      <span className={styles.label}>Status</span>
      <span className={styles.soldAsLabel}>
        Sold as
        <Tooltip arrow variant="dark" custom title={<SoldAsTooltipContent />}>
          <span data-testid="programs-sold-as-tooltip-anchor">
            <FontAwesomeIcon
              icon={faInfoCircle}
              className={styles.tooltipIcon}
            />
          </span>
        </Tooltip>
      </span>
      <span className={styles.labelCenter}>Rating</span>
      <span className={styles.labelBegins}>Begins</span>
      <span className={styles.labelCompletion}>Completion</span>
      <span className={styles.labelComments}>Comments</span>
      <span className={styles.labelStatsPlaceholder} />
      <span />
      <span />
    </div>
  );
};
